import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["descriptionField", "submitBtn", "templateField", "templateSelect",
                    "briefField", "briefInput", "briefName", "briefClear"]

  selectAi() {
    this.descriptionFieldTarget.style.display = ""
    if (this.hasBriefFieldTarget) this.briefFieldTarget.style.display = ""
    this.submitBtnTarget.value = this.submitBtnTarget.dataset.aiLabel
    if (this.hasTemplateFieldTarget) this.templateFieldTarget.classList.add("hidden")
    if (this.hasTemplateSelectTarget) this.templateSelectTarget.removeAttribute("required")
  }

  selectManual() {
    this.descriptionFieldTarget.style.display = "none"
    if (this.hasBriefFieldTarget) this.briefFieldTarget.style.display = "none"
    this.submitBtnTarget.value = this.submitBtnTarget.dataset.manualLabel
    if (this.hasTemplateFieldTarget) this.templateFieldTarget.classList.add("hidden")
    if (this.hasTemplateSelectTarget) this.templateSelectTarget.removeAttribute("required")
  }

  selectTemplate() {
    this.descriptionFieldTarget.style.display = "none"
    if (this.hasBriefFieldTarget) this.briefFieldTarget.style.display = "none"
    this.submitBtnTarget.value = this.submitBtnTarget.dataset.templateLabel || this.submitBtnTarget.dataset.manualLabel
    if (this.hasTemplateFieldTarget) this.templateFieldTarget.classList.remove("hidden")
    if (this.hasTemplateSelectTarget) this.templateSelectTarget.setAttribute("required", "required")
  }

  briefChanged() {
    const file = this.briefInputTarget.files[0]
    this.briefNameTarget.textContent = file ? file.name : this.briefNameTarget.dataset.placeholder
    this.briefClearTarget.classList.toggle("hidden", !file)
  }

  clearBrief(event) {
    event.preventDefault()
    event.stopPropagation()
    this.briefInputTarget.value = ""
    this.briefChanged()
  }
}
